"use client";

import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react";

interface CheckoutDebugContextValue {
  isVisible: boolean;
  toggle: () => void;
}

const CheckoutDebugContext = createContext<CheckoutDebugContextValue>({
  isVisible: false,
  toggle: () => undefined,
});

export const CheckoutDebugWrapper = ({ children }: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(false);
  const toggle = useCallback(() => setIsVisible((v) => !v), []);
  return (
    <CheckoutDebugContext.Provider value={{ isVisible, toggle }}>
      {children}
    </CheckoutDebugContext.Provider>
  );
};

export const useCheckoutDebugContext = () => useContext(CheckoutDebugContext);
